import {
	isRouteMenuPoint,
	MenuPoint,
	NavColor,
	NavColors,
	NavTranslations,
} from '@agilox/ui-common';
import { Component, ElementRef, HostListener, inject, input, output, signal } from '@angular/core';
import { AppMenuPoint } from '@agilox/common';

@Component({
	selector: 'ui-mobile-nav',
	templateUrl: './mobile-nav.component.html',
	standalone: false,
})
export class MobileNavComponent {
	private elementRef: ElementRef = inject(ElementRef);

	logoPath = input<string | undefined>();
	items = input<MenuPoint[] | undefined>();
	navColor = input<NavColor>(NavColors.Dark);
	apps = input<AppMenuPoint[]>([]);
	activeApp = input<AppMenuPoint | undefined>();
	appNavVisible = input<boolean>(true);
	environment = input<string>('live');
	navTranslations = input<NavTranslations>();
	currentUrl = input<string>('');

	openedMenuPoint = signal<MenuPoint | undefined>(undefined);
	appNavOpen = signal<boolean>(false);

	callbackEvent = output<MenuPoint>();

	onMenuPointClick(menuPoint: MenuPoint) {
		/**
		 * If the menupoint has a callback, emit the callback event
		 * and do not route
		 */
		if (menuPoint.callback) {
			this.callbackEvent.emit(menuPoint);
		} else if (!menuPoint.submenus && menuPoint.url) {
			this.doRouting();
		} else {
			/**
			 * MenuPoint has submenus
			 * if closed: close all other submenus then open submenu
			 * else: close submenu
			 */
			if (this.openedMenuPoint() !== menuPoint) {
				this.openedMenuPoint.set(menuPoint);
				this.appNavOpen.set(false);
			} else {
				this.closeMenu();
			}
		}
	}

	doRouting() {
		this.closeMenu();
	}

	isRouteItem(item: MenuPoint): boolean {
		return isRouteMenuPoint(item);
	}

	closeMenu() {
		this.openedMenuPoint.set(undefined);
	}

	@HostListener('document:click', ['$event'])
	onDocumentClick(event: any) {
		const target = event.target as HTMLElement;
		const inside = this.elementRef.nativeElement.contains(target);
		if (!inside) {
			this.closeMenu();
		}
	}

	clickInsideNav(event: Event): void {
		const target = event?.target as HTMLElement;

		const isMobileNavList = target?.closest('[data-id*="mobile-nav-list"]');
		const isNavigationElement = target?.closest('[data-id*="nav-element-span-"]');

		if (isMobileNavList || isNavigationElement) {
			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();
		}
	}

	onAppNavToggled(open: boolean): void {
		this.appNavOpen.set(open);
		if (open && this.openedMenuPoint()) {
			this.closeMenu();
		}
	}
}
